import type { ReactNode } from 'react';

import { Spinner, Text, Icon } from '@sso/shared/core';

import { Container, Header, TitleContainer } from './PublicPageLayout.styles';

type PublicPageLayoutProps = {
    description?: ReactNode;
    children?: ReactNode;
    header?: ReactNode;
    title?: ReactNode;
    withDomain?: boolean;
    isLoading?: boolean;
    className?: string;
};

function PublicPageLayout({
    description,
    withDomain,
    className,
    isLoading,
    children,
    header,
    title,
}: PublicPageLayoutProps) {
    if (isLoading) {
        return <Spinner absolute />;
    }

    return (
        <>
            {header}
            <Container className={className}>
                <Header>
                    <TitleContainer>
                        {title && (
                            <Text color="neutral.body" weight="semiBold" size="displayMd" as="h1">
                                {title}
                            </Text>
                        )}
                        {description && (
                            <Text color="neutral.subtitle" size="textMd" as="p">
                                {description}
                            </Text>
                        )}
                    </TitleContainer>
                    {withDomain && (
                        <Icon
                            name="building-skyscraper"
                            color="neutral.border"
                            strokeWidth={1}
                            height={48}
                            width={48}
                            mt={6}
                        />
                    )}
                </Header>
                {children}
            </Container>
        </>
    );
}

export default PublicPageLayout;
